import { MantineThemeOverride } from '@mantine/core';

export type FileButtonTheme = NonNullable<MantineThemeOverride['components']>['FileButton'];

export const FileButton: FileButtonTheme = {
  // todo: define
};
